import { BaseReq } from "@/core/interface";

export class UserSimpleListReq extends BaseReq {
  activatedStatus: number | undefined = undefined; // 激活状态 1: 激活, 0: 未激活
  status: number | undefined = undefined; // 账号状态 1: 正常, 0: 禁用
  onJob: boolean | undefined = undefined; // 是否在职
  realName: string | undefined = undefined; // 姓名
  state:string | undefined = undefined;//员工状态（试用：sy）
  staffType : string   // 劳务type
}

export class UserSimpleRecord {
  id: string = "";
  realName: string = "";
  disabled: boolean = false;
}

export class UserSimpleListResp {
  records: UserSimpleRecord[] = [];
}
